module.exports = __webpack_public_path__ + "static/media/DetailCardPlaceholder.01b13c2d.svg";